module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_1a-502879c3f0cf88e99a332f68d9b70643.jpg";